var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('router-link', {
    attrs: {
      "to": _vm.path,
      "exact": _vm.exact
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        isActive
      }) {
        return [_c('li', {
          staticClass: "nav-item rounded",
          class: {
            active: isActive
          },
          on: {
            "click": _vm.collapse
          }
        }, [_c('router-link', {
          staticClass: "nav-link",
          attrs: {
            "to": _vm.path
          }
        }, [_vm._v(" " + _vm._s(_vm.label) + " "), isActive ? _c('span', {
          staticClass: "sr-only"
        }, [_vm._v("(current)")]) : _vm._e()])], 1)];
      }
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };